import React, { useState, useEffect } from 'react';
import { FaGamepad, FaInfoCircle, FaImage, FaClipboardList } from 'react-icons/fa';
import Modal from 'react-modal';
import gameService from '../../services/gameService';
import './AddGame.css';

Modal.setAppElement('#root');

const AddGame = () => {
  const [sessions, setSessions] = useState([]);
  const [selectedSession, setSelectedSession] = useState('');
  const [gameName, setGameName] = useState('');
  const [gameDetails, setGameDetails] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [urlGame, setUrlGame] = useState('');
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState('');

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        let sessionsData = await gameService.getGameSessions();
        
        const uniqueSessions = Array.from(new Set(sessionsData.map(session => session.session_id)))
          .map(id => sessionsData.find(session => session.session_id === id));
  
        setSessions(uniqueSessions);
      } catch (error) {
        console.error('Error fetching game sessions:', error.message);
      }
    };
  
    fetchSessions();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const gameData = {
      sessionId: selectedSession,
      gameName,
      gameDetails,
      imageUrl,
      urlGame,
    };

    try {
      const response = await gameService.addGameToSession(gameData);
      setModalContent(`Game added successfully with ID: ${response.gameId}`);
      openModal();
      resetForm();
    } catch (error) {
      setModalContent('Failed to add game. Please try again.');
      openModal();
    }
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const resetForm = () => {
    setGameName('');
    setGameDetails('');
    setImageUrl('');
    setUrlGame('');
    setSelectedSession('');
  };

  return (
    <div className="add-game-container">
      <h2>Add Game to Session</h2>
      <form onSubmit={handleSubmit} className="add-game-form">
        <div className="form-group">
          <label htmlFor="session-select">
            <FaClipboardList className="icon" /> Session:
          </label>
          <select
            id="session-select"
            className="form-control"
            value={selectedSession}
            onChange={(e) => setSelectedSession(e.target.value)}
            required
          >
            <option value="">Select a session</option>
            {sessions.map(session => (
              <option key={session.session_id} value={session.session_id}>
                {session.session_name}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="game-name">
            <FaGamepad className="icon" /> Game Name:
          </label>
          <input
            id="game-name"
            className="form-control"
            type="text"
            value={gameName}
            onChange={(e) => setGameName(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="game-details">
            <FaInfoCircle className="icon" /> Game Details:
          </label>
          <textarea
            id="game-details"
            className="form-control"
            value={gameDetails}
            onChange={(e) => setGameDetails(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label htmlFor="image-url">
            <FaImage className="icon" /> Image URL:
          </label>
          <input
            id="image-url"
            className="form-control"
            type="text"
            value={imageUrl}
            onChange={(e) => setImageUrl(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label htmlFor="url-game">
            <FaGamepad className="icon" /> Game URL:
          </label>
          <input
            id="url-game"
            className="form-control"
            type="text"
            value={urlGame}
            onChange={(e) => setUrlGame(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="submit-button">
          Add Game
        </button>
      </form>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Result Modal"
        className="add-game-container-modal-content"
        overlayClassName="add-game-container-modal-overlay"
      >
        <h2>Information</h2>
        <p>{modalContent}</p>
        <button onClick={closeModal} className="close-modal-button">
          Close
        </button>
      </Modal>
    </div>
  );
};

export default AddGame;
